import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import styles from './styles/SubscriptionDetails.module.css';

export const SubscriptionDetails = () => {
  const { customerId } = useParams();
  const [subscription, setSubscription] = useState(null);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [loading, setLoading] = useState(false);

  console.log('Customer ID:', customerId);
  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      try {
        const response = await axios.get(`http://localhost:5000/subscriptions/${customerId}`);
          
        if (response.data && response.data.status) { 
          setSubscription(response.data);
          setSelectedPlan(response.data.plan?.id || '');
        } else {
          setSubscription(false); 
        }
      } catch (error) {
        console.error('Error fetching subscription details:', error);
        setSubscription(false);
      }
    };
  
    const fetchPlans = async () => {
      try {
        const response = await axios.get('http://localhost:5000/plans');
        console.log("Plans Response:", response.data);
        setPlans(response.data);
      } catch (error) {
        console.error('Error fetching plans:', error);
      }
    };
  
    fetchSubscriptionDetails();
    fetchPlans();
  }, [customerId]);

  const handleCancelSubscription = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `http://localhost:5000/subscriptions/${subscription.id}/cancel`
      );
      setSubscription(response.data); 
    } catch (error) {
      console.error('Error canceling subscription:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleResumeSubscription = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `http://localhost:5000/subscriptions/${subscription.id}/resume`
      );
      setSubscription(response.data);
    } catch (error) {
      console.error('Error resuming subscription:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleChangePlan = async () => {
      if (!selectedPlan) {
        alert('Please select a plan');
        return;
      }

      setLoading(true);
      try {
        const response = await axios.post(`http://localhost:5000/subscriptions/${subscription.id}/change`, {
          newPriceId: selectedPlan,
        });
        setSubscription(response.data);
      } catch (error) {
        console.error('Error changing subscription:', error);
      } finally {
        setLoading(false);
      }
    };

  // if (!subscription) {
  //   return <div>Loading subscription details...</div>;
  // }

  if (subscription === null) {
    return <div className={styles.noSubscriptionMessage}>Loading subscription details...</div>;
  }
  
  if (subscription === false) {
    return <div className={styles.noSubscriptionMessage}>The user hasn't subscribed.</div>;
  }

  return (
    <div className={styles.subscriptionDetails}>
      <h1>Subscription Details</h1>
      <p><strong>Subscription ID:</strong> {subscription.id}</p>
      <p><strong>Subscription Start:</strong> {new Date(subscription.start_date * 1000).toLocaleDateString()}</p>
      <p><strong>Renew Date:</strong> {new Date(subscription.current_period_end * 1000).toLocaleDateString()}</p>
      <p><strong>End Date:</strong> {subscription.cancel_at_period_end ? 'Canceled at period end' : 'Active'}</p>
      <p><strong>Payment Method:</strong> {subscription.payment_method ? subscription.payment_method.card.brand : 'N/A'}</p>

      <div className={styles.actions}>
        {subscription.cancel_at_period_end ? (
          <button onClick={handleResumeSubscription} disabled={loading} className={styles.button}>
            {loading ? 'Resuming...' : 'Resume Subscription'}
          </button>
        ) : (
          <button onClick={handleCancelSubscription} disabled={loading} className={styles.button}>
            {loading ? 'Canceling...' : 'Cancel Subscription'}
          </button>
        )}
      </div>
      <div className={styles.changePlan}>
        <h2>Change Plan</h2>
        <select value={selectedPlan} onChange={(e) => setSelectedPlan(e.target.value)}>
          <option value="">Select a new plan</option>
          {plans.map((plan) => (
            <option key={plan.id} value={plan.price_id}>
              {plan.name} - ${plan.price / 100}/month
            </option>
          ))}
        </select>
        <button onClick={handleChangePlan} disabled={loading || !selectedPlan} className={styles.button}>
          {loading ? 'Updating...' : 'Change Plan'}
        </button>
      </div>
    </div>
  );
};